<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import flatpickr from 'flatpickr'
    import { DateTime } from 'luxon'
    import get from 'lodash/get'
    import Icon from 'fa-svelte'
    import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
    import '@/flatpickr/dist/flatpickr.min.css'
    import '@/flatpickr/dist/themes/dark.css'

    import Btn from 'src/fields/Button.svelte'

    const dispatch = createEventDispatcher()
    export let segment

    let datepicker
    let timepickerFrom
    let timepickerTo

    const toISODate = date => DateTime.fromJSDate(date).toISODate()
    const toTime = date => DateTime.fromJSDate(date).toFormat('hh:mm')
    const fromISODate = date => DateTime.fromISO(date).toJSDate()
    const fromTime = time => DateTime.fromFormat(time, 'HH:mm').toJSDate()

    const removeSegment = () => dispatch('remove', segment)

    onMount(() => {
        flatpickr(datepicker, {
            mode: 'range',
            defaultDate: segment.date_range.map(fromISODate),
            onChange: function (selectedDates, dateStr, instance) {
                segment = { ...segment, date_range: selectedDates.map(toISODate) }
            },
        })
        flatpickr(timepickerFrom, {
            mode: 'time',
            dateFormat: 'h:i:K',
            defaultDate: get(segment, ['time_range', 0]),
            onChange: function (selectedDates, dateStr, instance) {
                segment = { ...segment, time_range: [toTime(selectedDates[0]), segment.time_range[1]] }
            },
        })
        flatpickr(timepickerTo, {
            mode: 'time',
            dateFormat: 'h:i:K',
            defaultDate: get(segment, ['time_range', 1]),
            onChange: function (selectedDates, dateStr, instance) {
                segment = { ...segment, time_range: [segment.time_range[0], toTime(selectedDates[0])] }
            },
        })
    })
</script>

<div class="segment">
    <div class="form">
        <input bind:this={datepicker} class="date-picker" placeholder="Date range"/>
        <input bind:this={timepickerFrom} class="time-picker" placeholder="From"/>
        <input bind:this={timepickerTo} class="time-picker" placeholder="To"/>
    </div>

    <div class="btns">
        <Btn on:click={removeSegment} type="danger" size="mini" roundType="circle" class="btn">
            <Icon icon={faTrash}/>
        </Btn>
    </div>
</div>

<style>
    .segment {
        background-color: #f3f3f3;
        padding: 10px;
        border-radius: 6px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .form {
        display: flex;
        flex-flow: row wrap;
    }

    .form > * {
        margin-right: 10px;
    }


    .date-picker {
        width: 220px;
    }

    .time-picker {
        width: 100px;
    }

    .btns {
        flex: 0 0 29px;
        margin-left: 10px;
    }
</style>
